<template>
    <add-to-cart-base :id="id">
        <template slot-scope="{ addItem }">
            <button
                class="btn btn-primary"
                @click="addItem"
            >
                {{ __('Add') }}
                <i class="fa fa-cart" />
            </button>
        </template>
    </add-to-cart-base>
</template>

<script>
export default {
    name: 'AddToCart',
    props: {
        id: {
            type: Object,
            required: true
        }
    }
}
</script>
